import { Download16 } from '@carbon/icons-react';
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { UploadFileWithAttachment } from 'api/attachments';
import { StatusUpdate, StatusUpdatesAPI } from 'api/status-updates';
import { convertFileAttachmentToUploadFileWithAttachment } from 'components/molecules/attachments';
import { AttachmentsTable } from 'components/molecules/attachments/table';
import { DownloadLink } from 'components/molecules/download-link/download-link';
import { useIsResponsive } from 'hooks/use-media-query';
import { handleDownload } from 'utils/attachment';
import {
  CPListOrGridSwitcher,
  CpListOrGridSwitcherType,
} from '../../components/cp-list-or-grid-switcher';
import {
  ActionsWrapper,
  IconWrapper,
  SectionName,
  SectionWrapper,
  TitleWrapper,
} from '../../components/task-drawer/sections/components';
import { CpAttachmentGridView } from '../../components/task-drawer/sections/cp-task-attachments-section';

const Wrapper = styled(SectionWrapper)`
  width: 100%;
  [data-test-id='remove-attachment-button-grid'] {
    display: none;
  }
  [data-test-id='remove-attachment-button-table'] {
    display: none;
  }
`;
const GridView = styled(CpAttachmentGridView)`
  margin-bottom: 0px;
`;

interface Props {
  statusUpdate: StatusUpdate;
}
export const CustomerPortalProjectUpdateAttachments: FC<Props> = ({
  statusUpdate,
}) => {
  const isResponsive = useIsResponsive();
  const [viewType, setViewType] = useState<CpListOrGridSwitcherType>(
    CpListOrGridSwitcherType.GRID,
  );

  useEffect(() => {
    setViewType(CpListOrGridSwitcherType.GRID);
  }, [isResponsive]);
  const attachmentFiles = useMemo(
    () =>
      convertFileAttachmentToUploadFileWithAttachment(
        statusUpdate.attachments ?? [],
      ),
    [statusUpdate.attachments],
  );
  const onDownload = useCallback(
    (file: UploadFileWithAttachment) =>
      handleDownload(file?.attachment?.attachmentId),
    [],
  );
  const onRemoveFile = useCallback(() => {}, []);

  return (
    <Wrapper>
      <TitleWrapper>
        <SectionName>
          <FormattedMessage id="attachments" />
        </SectionName>
        <ActionsWrapper>
          <CPListOrGridSwitcher
            type={viewType}
            onChange={(type) => setViewType(type)}
          />
          <DownloadLink
            url={StatusUpdatesAPI.downloadStatusUpdateAttachmentsUrl(
              statusUpdate.statusUpdateId,
            )}
          >
            <IconWrapper>
              <Download16 />
            </IconWrapper>
          </DownloadLink>
        </ActionsWrapper>
      </TitleWrapper>
      {attachmentFiles.length > 0 ? (
        <>
          {viewType === CpListOrGridSwitcherType.GRID ? (
            <GridView
              attachmentFiles={attachmentFiles}
              onRemoveFile={onRemoveFile}
              onDownloadFile={onDownload}
            />
          ) : (
            <AttachmentsTable
              filesList={attachmentFiles}
              onDownloadFile={onDownload}
              onRemoveFile={onRemoveFile}
            />
          )}
        </>
      ) : (
        <></>
      )}
    </Wrapper>
  );
};
